import { constants } from "redux/constants/redux-constants";

const initialState = {
    intakeForm:{},
    intakeFormLoading:false,

  };

  const CopilotReducer=(state = initialState, action)=>{
    switch (action.type) {
        case constants?.COPILOT?.SET_INTAKE_FORM:
          return {
            ...state,
            intakeForm: action?.payload,
          };

        case constants?.COPILOT?.SET_INTAKE_FORM_LOADING:
          return {
            ...state,
            intakeFormLoading: action?.payload,
          };
    
        default:
          return {
            ...state,
          };
      }
  }

  export default CopilotReducer